import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import ContentCardWrapperV4 from '../../../common/component/ContentCardWrapperV4';
import FetchResultWrapper from '../../../common/component/FetchResultWrapper';
import {Page} from '../../../common/constant/page';
import useLogin from '../../../common/hook/useLogin';
import {routeTo} from '../../../common/util/PageRouter';
import {IMyPageContentItem} from '../../../commonSub/type';
import {sendHomeEvent} from '../../common/tracking';
import MyContentCardV4 from '../component/MyContentCardV4';
import TextWithArrowV4 from '../component/TextWithArrowV4';
import ToggleWithContentV4 from '../component/ToggleWithContentV4';
import {actions} from '../state/action';
import {IClickContentProps, IEditPropsV4, IPurchaseV4} from '../type';

interface IProps extends IEditPropsV4, IClickContentProps {
  purchase?: IPurchaseV4;
}

export default function PurchaseTabV4({
  purchase,
  isEdit,
  showLoading,
  selectedList = {},
  onToggle,
  onClickContent,
}: IProps) {
  const {isLogin} = useLogin();
  const {t} = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      if (isEdit) {
        dispatch(actions.setPropertyValues('editTab', {own: undefined}));
      }
    };
  }, [isEdit, dispatch]);

  const handleClickEpisode = (content: IMyPageContentItem, index: number) => {
    sendHomeEvent({
      actionName: 'episode',
      action: 'click',
      customProps: {
        content_id: content.id,
        ordnum: index + 1,
      },
    });

    routeTo({
      page: Page.MyPageEpisodeList,
      contentId: content.id,
      contentSid: content.sid,
    });
  };

  return (
    <FetchResultWrapper
      showLoading={!purchase || showLoading}
      showNoLogin={!isLogin}
      showNoItems={!!purchase && purchase.contents.length === 0}
      noLoginProps={{
        textKey: 'library_tab_possessed_before_login',
      }}
      noItemsProps={{
        textKey: 'library_tab_possessed_unavailable_series',
      }}
    >
      <ContentCardWrapperV4 isBig>
        {(purchase?.contents || [])
          .filter(item => isEdit || !item.isHidden)
          .map(({id, content, remainLicenseCount}, index) => (
            <MyContentCardV4
              key={content.id}
              content={isEdit ? {...content, badges: []} : content}
              isDimmed={selectedList[id]}
              onClick={() =>
                isEdit ? onToggle?.(id) : onClickContent?.(content, index)
              }
              onClickBottom={() =>
                isEdit ? onToggle?.(id) : handleClickEpisode(content, index)
              }
              isBig
            >
              <ToggleWithContentV4
                toggleType="slide"
                showToggle={isEdit}
                isSelected={!selectedList[id]}
              >
                <TextWithArrowV4
                  text={t('library_tab_possessed_episode_button', {
                    count: remainLicenseCount,
                  })}
                />
              </ToggleWithContentV4>
            </MyContentCardV4>
          ))}
      </ContentCardWrapperV4>
    </FetchResultWrapper>
  );
}
